import {
  setLoading,
  setWalletAddress,
  setUser,
  setCompleted,
  setShow,
} from "./reducer";

export const setLoadingTrue = () => (dispatch) => {
  dispatch(setLoading(true));
};

export const setLoadingFalse = () => (dispatch) => {
  dispatch(setLoading(false));
};

export const setWalletAddressValue = (data) => (dispatch) => {
  dispatch(setWalletAddress(data));
};

export const setUserData = (data) => (dispatch) => {
  dispatch(setUser(data));
};

export const setPromotionTrue = () => (dispatch) => {
  dispatch(setCompleted(true));
};
export const setPromotionFalse = () => (dispatch) => {
  dispatch(setCompleted(false));
};

export const setInstructionTrue = () => (dispatch) => {
  dispatch(setShow(true));
};
export const setInstructionFalse = () => (dispatch) => {
  dispatch(setShow(false));
};
